import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss'
})
export class PaginatorComponent {
  private _pageSize = 10;
  @Input() set pageSize(value: number) {
    this._pageSize = value;
    this.calculateTotalPages();
  }
  get pageSize() {
    return this._pageSize;
  }
  @Input() currentPage = 1;
  @Input() totalPages = 0;
  private _totalItems = 0;
  @Input() set totalItems(value: number) {
    this._totalItems = value;
    this.calculateTotalPages();
  }
  get totalItems() {
    return this._totalItems;
  }
  items: any[] = Array.from({ length: 100 }, (_, i) => `Item ${i + 1}`);
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Input() pageSizeOptions = [10, 20, 30, 40, 50];
  constructor() { }

  calculateTotalPages() {
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
  }
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.pageChange.emit(this.currentPage);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageChange.emit(this.currentPage);
    }
  }
  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
    }
  }
  onPageSizeChange(event: any) {
    this.pageSize = +event.target.value;
    this.calculateTotalPages();
    this.pageSizeChange.emit(this.pageSize);
    this.currentPage = 1;  // Reset to first page when page size changes
    this.pageChange.emit(this.currentPage);
  }
  getPagesRange(): number[] {
    const startPage = Math.max(1, this.currentPage - 2);
    const endPage = Math.min(this.totalPages, this.currentPage + 3);
    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }
}
